import { ChannelAction, ChannelInitStateType } from "../../common";

const initState: ChannelInitStateType = {
  active: 0,
  channelList: [],
};

export default function channel(state = initState, action: ChannelAction) {
  switch (action.type) {
    case "channel/getChannelList":
      return {
        ...state,
        channelList: action.payLoad,
      };
    case "channel/changeActive":
      return {
        ...state,
        active: action.payLoad,
      };

    default:
      return state;
  }
}
